"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._claimETHFromRageQuit = exports._batchClaimETHFromRageQuit = exports._fetchETHFromRageQuit = exports._batchFetchETHFromRageQuit = exports._batchPartialWithdrawal = exports._previewPartialWithdrawalClaimableETH = exports._withdrawETH = exports._getIdleETH = exports._depositETH = exports._bringUnusedETHBackIntoGiantPool = exports._withdrawDETH = exports._batchDepositETHForStaking = void 0;
const constants_1 = require("./constants");
const contracts_1 = require("./contracts");
const utils_1 = require("./utils");
const _batchDepositETHForStaking = (signer, savETHVaultAddresses, amounts, blsPublicKeys, stakeAmounts) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = savETHVaultAddresses.length;
    if (arrayLength != amounts.length || arrayLength != blsPublicKeys.length || arrayLength != stakeAmounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < arrayLength; ++i) {
        const blsArray = blsPublicKeys[i];
        const stakeArray = stakeAmounts[i];
        if (blsArray.length != stakeArray.length) {
            throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
        }
        savETHVaultAddresses[i] = (0, utils_1._add0x)(savETHVaultAddresses[i]);
        for (let j = 0; j < blsArray.length; ++j) {
            blsPublicKeys[i][j] = (0, utils_1._add0x)(blsPublicKeys[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.batchDepositETHForStaking(savETHVaultAddresses, amounts, blsPublicKeys, stakeAmounts);
});
exports._batchDepositETHForStaking = _batchDepositETHForStaking;
const _withdrawDETH = (signer, savETHVaultAddresses, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = savETHVaultAddresses.length;
    if (arrayLength != lpTokens.length || arrayLength != amounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < arrayLength; ++i) {
        const lpArray = lpTokens[i];
        const amountArray = amounts[i];
        if (lpArray.length != amountArray.length) {
            throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
        }
        savETHVaultAddresses[i] = (0, utils_1._add0x)(savETHVaultAddresses[i]);
        for (let j = 0; j < lpArray.length; ++j) {
            lpTokens[i][j] = (0, utils_1._add0x)(lpTokens[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.withdrawDETH(savETHVaultAddresses, lpTokens, amounts);
});
exports._withdrawDETH = _withdrawDETH;
const _bringUnusedETHBackIntoGiantPool = (signer, savETHVaultAddresses, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = savETHVaultAddresses.length;
    if (arrayLength != lpTokens.length || arrayLength != amounts.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < arrayLength; ++i) {
        const lpArray = lpTokens[i];
        const amountArray = amounts[i];
        if (lpArray.length != amountArray.length) {
            throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
        }
        savETHVaultAddresses[i] = (0, utils_1._add0x)(savETHVaultAddresses[i]);
        for (let j = 0; j < lpArray.length; ++j) {
            lpTokens[i][j] = (0, utils_1._add0x)(lpTokens[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.bringUnusedETHBackIntoGiantPool(savETHVaultAddresses, lpTokens, amounts);
});
exports._bringUnusedETHBackIntoGiantPool = _bringUnusedETHBackIntoGiantPool;
const _depositETH = (signer, amount, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.depositETH(amount, { value: ethValue });
});
exports._depositETH = _depositETH;
const _getIdleETH = (signer) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.idleETH();
});
exports._getIdleETH = _getIdleETH;
const _withdrawETH = (signer, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.withdrawETH(amount);
});
exports._withdrawETH = _withdrawETH;
const _previewPartialWithdrawalClaimableETH = (signer, user, savETHVaultAddresses, lpTokens) => __awaiter(void 0, void 0, void 0, function* () {
    if (savETHVaultAddresses.length != lpTokens.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < savETHVaultAddresses.length; ++i) {
        savETHVaultAddresses[i] = (0, utils_1._add0x)(savETHVaultAddresses[i]);
        for (let j = 0; j < lpTokens[i].length; ++j) {
            lpTokens[i][j] = (0, utils_1._add0x)(lpTokens[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.previewPartialWithdrawalClaimableETH(user, savETHVaultAddresses, lpTokens);
});
exports._previewPartialWithdrawalClaimableETH = _previewPartialWithdrawalClaimableETH;
const _batchPartialWithdrawal = (signer, savETHVaultAddresses, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = savETHVaultAddresses.length;
    if (arrayLength != amounts.length || arrayLength != lpTokens.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < arrayLength; ++i) {
        const lpTokensArray = lpTokens[i];
        const amountsArray = amounts[i];
        if (lpTokensArray.length != amountsArray.length) {
            throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
        }
        savETHVaultAddresses[i] = (0, utils_1._add0x)(savETHVaultAddresses[i]);
        for (let j = 0; j < lpTokensArray.length; ++j) {
            lpTokens[i][j] = (0, utils_1._add0x)(lpTokens[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.batchPartialWithdrawal(savETHVaultAddresses, lpTokens, amounts);
});
exports._batchPartialWithdrawal = _batchPartialWithdrawal;
const _batchFetchETHFromRageQuit = (signer, savETHVaultAddresses, lpTokens, amounts) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayLength = savETHVaultAddresses.length;
    if (arrayLength != amounts.length || arrayLength != lpTokens.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < arrayLength; ++i) {
        const lpTokensArray = lpTokens[i];
        const amountsArray = amounts[i];
        if (lpTokensArray.length != amountsArray.length) {
            throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
        }
        savETHVaultAddresses[i] = (0, utils_1._add0x)(savETHVaultAddresses[i]);
        for (let j = 0; j < lpTokensArray.length; ++j) {
            lpTokens[i][j] = (0, utils_1._add0x)(lpTokens[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    return contract.batchFetchETHFromRageQuit(savETHVaultAddresses, lpTokens, amounts);
});
exports._batchFetchETHFromRageQuit = _batchFetchETHFromRageQuit;
const _fetchETHFromRageQuit = (signer, savETHVaultAddress, lpToken, amount) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports._batchFetchETHFromRageQuit)(signer, [savETHVaultAddress], [[lpToken]], [[amount]]);
});
exports._fetchETHFromRageQuit = _fetchETHFromRageQuit;
const _batchClaimETHFromRageQuit = (signer, blsPublicKeys) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).giantSavETHPool();
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, utils_1._add0x)(blsPublicKeys[i]);
    }
    return contract.batchClaimETHFromRageQuit(blsPublicKeys);
});
exports._batchClaimETHFromRageQuit = _batchClaimETHFromRageQuit;
const _claimETHFromRageQuit = (signer, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports._batchClaimETHFromRageQuit)(signer, [blsPublicKey]);
});
exports._claimETHFromRageQuit = _claimETHFromRageQuit;
